const ViewMode = Object.freeze({
  CALL: 'call',
  GRID: 'grid',
  SINGLE: 'single',
});

export default ViewMode;
